module.exports = __webpack_public_path__ + "static/media/rentRates3BedroomAllDwellings-01.07cf0b35.png";